export const MIME_TYPES = {
  PNG: 'image/png',
  JPEG: 'image/jpeg',
  MP4: 'video/mp4',
};
